import AllPostsPage from './AllPostsPage';

export default AllPostsPage;